var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("h3", { staticClass: "text-center mb-6" }, [
        _vm._v(" " + _vm._s(_vm.$t("roomWizard.appearanceDescription")) + " ")
      ]),
      _c(
        "v-form",
        {
          ref: "newLicenseForm",
          attrs: { onSubmit: "return false;" },
          model: {
            value: _vm.valid,
            callback: function($$v) {
              _vm.valid = $$v
            },
            expression: "valid"
          }
        },
        [
          _c("va-text-field", {
            staticClass: "mb-6",
            attrs: {
              rules: [_vm.required, _vm.maxLength(_vm.config.roomName, 255)],
              label: _vm.$t("roomWizard.deviceName")
            },
            model: {
              value: _vm.config.roomName,
              callback: function($$v) {
                _vm.$set(_vm.config, "roomName", $$v)
              },
              expression: "config.roomName"
            }
          }),
          _vm.isWizardFeatureEnabled("logo", true)
            ? _c(
                "div",
                { staticClass: "d-sm-flex mb-4" },
                [
                  _c("va-switch", {
                    staticClass: "mr-auto",
                    attrs: { text: _vm.$t("roomWizard.customLogo") },
                    model: {
                      value: _vm.config.showCustomLogo,
                      callback: function($$v) {
                        _vm.$set(_vm.config, "showCustomLogo", $$v)
                      },
                      expression: "config.showCustomLogo"
                    }
                  }),
                  _vm.config.showCustomLogo
                    ? _c("file-uploader", {
                        staticClass: "mr-4",
                        attrs: {
                          title: _vm.$t("roomWizard.customLogoUploader"),
                          accept: [".png", ".jpg", ".jpeg"],
                          "file-type": 2
                        },
                        on: { upload: _vm.onUploadLogo }
                      })
                    : _vm._e()
                ],
                1
              )
            : _vm._e(),
          _vm.isWizardFeatureEnabled("backgrounds", true)
            ? _c(
                "div",
                { staticClass: "d-sm-flex mb-4" },
                [
                  _c("va-switch", {
                    staticClass: "mr-auto",
                    attrs: { text: _vm.$t("roomWizard.customBg") },
                    model: {
                      value: _vm.config.showCustomBackgrounds,
                      callback: function($$v) {
                        _vm.$set(_vm.config, "showCustomBackgrounds", $$v)
                      },
                      expression: "config.showCustomBackgrounds"
                    }
                  }),
                  _vm.config.showCustomBackgrounds
                    ? _c("file-uploader", {
                        staticClass: "mr-4",
                        attrs: {
                          title: _vm.$t("roomWizard.customBackgroundUploader"),
                          multiple: "",
                          accept: [".png", ".jpg", ".jpeg"],
                          "file-type": 1
                        },
                        on: { upload: _vm.onUploadBg }
                      })
                    : _vm._e()
                ],
                1
              )
            : _vm._e(),
          _vm.isWizardFeatureEnabled("wifi", true)
            ? _c(
                "div",
                { staticClass: "d-sm-flex mb-4" },
                [
                  _c("va-switch", {
                    staticClass: "mr-8",
                    attrs: { text: _vm.$t("roomWizard.showCustomWifi") },
                    model: {
                      value: _vm.config.customWifi,
                      callback: function($$v) {
                        _vm.$set(_vm.config, "customWifi", $$v)
                      },
                      expression: "config.customWifi"
                    }
                  }),
                  _c(
                    "div",
                    { staticClass: "flex-grow-1" },
                    [
                      _vm.config.customWifi
                        ? _c("va-text-field", {
                            staticClass: "mb-4",
                            attrs: {
                              rules: [_vm.required],
                              label: _vm.$t("roomWizard.customSSID")
                            },
                            model: {
                              value: _vm.config.customSSID,
                              callback: function($$v) {
                                _vm.$set(_vm.config, "customSSID", $$v)
                              },
                              expression: "config.customSSID"
                            }
                          })
                        : _vm._e(),
                      _vm.config.customWifi
                        ? _c("va-text-field", {
                            staticClass: "mb-4",
                            attrs: {
                              rules: [_vm.required],
                              label: _vm.$t("roomWizard.customPass")
                            },
                            model: {
                              value: _vm.config.customPass,
                              callback: function($$v) {
                                _vm.$set(_vm.config, "customPass", $$v)
                              },
                              expression: "config.customPass"
                            }
                          })
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.isWizardFeatureEnabled("screenSharingPin", true)
            ? _c("va-switch", {
                staticClass: "mb-4",
                attrs: { text: _vm.$t("roomWizard.screenSharingPin") },
                model: {
                  value: _vm.config.screenSharingPin,
                  callback: function($$v) {
                    _vm.$set(_vm.config, "screenSharingPin", $$v)
                  },
                  expression: "config.screenSharingPin"
                }
              })
            : _vm._e(),
          _vm.isWizardFeatureEnabled("rebootTime", true)
            ? _c("va-text-field", {
                attrs: {
                  rules: [_vm.timeAmPM],
                  label: _vm.$t("generalConfiguration.rebootTime")
                },
                model: {
                  value: _vm.config.rebootTime,
                  callback: function($$v) {
                    _vm.$set(_vm.config, "rebootTime", $$v)
                  },
                  expression: "config.rebootTime"
                }
              })
            : _vm._e(),
          _c(
            "div",
            { staticClass: "d-flex justify-space-between my-8" },
            [
              !_vm.first && !_vm.second
                ? _c("va-button", {
                    staticClass: "mr-4",
                    attrs: {
                      color: "secondary",
                      type: "outline",
                      cta: _vm.$t("roomWizard.prev")
                    },
                    on: { click: _vm.onBack }
                  })
                : _c("v-spacer"),
              _c("va-button", {
                attrs: {
                  disabled: !_vm.valid,
                  loading: _vm.loading,
                  cta: _vm.$t("roomWizard.next")
                },
                on: { click: _vm.onFinish }
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }